export const isEmptyObject = (value) => (Object.prototype.toString.call(value)==="[object Object]" && Object.keys(value).length==0);
export const isArray = (value) => Object.prototype.toString.call(value) === "[object Array]";
export const isObject = (value) => Object.prototype.toString.call(value) === "[object Object]";
export const isString = (value) => Object.prototype.toString.call(value) === "[object String]";
export const isNumber = (value) => Object.prototype.toString.call(value) === "[object Number]";
export const isEmpty = (obj) => (isObject(obj) && isEmptyObject(obj)) || (isArray(obj) && obj.length==0);
export const isAndroid = () => typeof android!=="undefined";

